import React, { useState } from "react";
import * as XLSX from "xlsx";

const ReportExcelButton = ({ filteredRows, reportTitle }) => {
  const [loading, setLoading] = useState(false);

  const exportToExcel = () => {
    try {
      setLoading(true);

      if (!filteredRows || filteredRows.length === 0) return;

      // Define the column sequence and map the JSON properties to display labels
      const columnMapping = [
        { key: "INVNO", label: "INV NO" },
        { key: "INV_DATE", label: "INV DATE" },
        { key: "CUSTOMER", label: "CUSTOMER" },
        { key: "SALES MAN", label: "SALES MAN" },
        { key: "ACCOUNT", label: "ACCOUNT" },
        { key: "TYPE", label: "CASH/CREDIT" },
        { key: "AMOUNT_EXCLVAT", label: "AMT EXCLVAT" },
        { key: "AMOUNT", label: "AMOUNT" }
      ];
      
      const headers = columnMapping.map(col => col.label);

      // 1. Build data rows mapping JSON database properties to Excel friendly labels
      const dataRows = filteredRows.map(row =>
        columnMapping.reduce((acc, col) => {
          let value = row[col.key];

          // Clean up ISO strings (e.g., "2026-06-17T00:00:00" -> "2026-06-17")
          if (col.key === "INV_DATE" && value && String(value).includes("T")) {
            value = String(value).split("T")[0];
          }

          acc[col.label] = value ?? "";
          return acc;
        }, {})
      );

      // 2. Calculate grand totals manually for only AMT EXCLVAT and AMOUNT
      const totalExclVat = filteredRows.reduce((sum, row) => sum + (Number(row.AMOUNT_EXCLVAT) || 0), 0);
      const totalAmount = filteredRows.reduce((sum, row) => sum + (Number(row.AMOUNT) || 0), 0);

      // 3. Build the Grand Total row lined up with the labels
      const totalsRow = columnMapping.reduce((acc, col, index) => {
        if (col.key === "AMOUNT_EXCLVAT") {
          acc[col.label] = totalExclVat;
        } else if (col.key === "AMOUNT") {
          acc[col.label] = totalAmount;
        } else if (index === 0) {
          acc[col.label] = "GRAND TOTAL";
        } else {
          acc[col.label] = ""; // Keep other columns blank under the total row
        }
        return acc;
      }, {});

      // Append grand total row to the bottom
      dataRows.push(totalsRow);

      const worksheet = XLSX.utils.json_to_sheet(dataRows, { header: headers });
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

      XLSX.writeFile(workbook, `${reportTitle}.xlsx`);
    } catch (err) {
      console.error("Excel export failed:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={exportToExcel}
      disabled={loading}
      className="flex items-center px-3 py-2 bg-green-600 hover:bg-green-700 text-white rounded-md text-sm font-medium transition duration-200"
    >
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
        strokeWidth="1.8" stroke="currentColor" className="w-5 h-5 mr-1">
        <path strokeLinecap="round" strokeLinejoin="round"
          d="M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2m-4-4-4 4m0 0-4-4m4 4V4" />
      </svg>
      {loading ? "Exporting..." : "Export Excel"}
    </button>
  );
};

export default ReportExcelButton;